export enum ROUTES {
    DASHBOARD = '/app',
    CONNECT_STRIPE = '/connect-stripe',
    LOGIN = '/login',
    REGISTER = '/register',
    PAGES = '/app/pages',
    PAGES_NEW = '/app/pages/new',
    PAGES_NEW_FLOW = '/app/pages/new/flow',
    PAGES_NEW_FEATURES = '/app/pages/new/features',
    PAGES_NEW_DESIGN = '/app/pages/new/design',
    PAGES_NEW_SNIPPET = '/app/pages/new/snippet',
    CUSTOMER_PORTALS = '/app/customer-portals',
    CUSTOMER_PORTALS_NEW = '/app/customer-portals/new',
    CUSTOMER_PORTALS_CONFIG = '/app/customer-portals/config',
    CUSTOMER_PORTALS_SNIPPET = '/app/customer-portals/snippet',
    FEATURE_FLAGS = '/app/feature-flags',
    FEATURE_FLAGS_CONFIGURE = '/app/feature-flags/:pageId',
    GATED_CONTENT = '/app/gated-content',
    GATED_CONTENT_NEW = '/app/gated-content/new',
    GATED_CONTENT_EDIT = '/app/gated-content/:id',
    GATED_CONTENT_SNIPPET = '/app/gated-content/:id/snippet',
    GATED_CONTENT_SHEETS = '/app/gated-content/sheets',
    GATED_CONTENT_SHEETS_EDIT = '/app/gated-content/sheets/:id',
    GATED_CONTENT_SHEETS_SNIPPET = '/app/gated-content/sheets/:id/snippet',
    INTEGRATIONS = '/app/integrations',
    INTEGRATIONS_BUBBLE = '/app/integrations/bubble',
    INTEGRATIONS_PAYPAL = '/app/integrations/paypal',
    INTEGRATIONS_REWARDFUL = '/app/integrations/rewardful',
    SETTINGS = '/app/settings',
    HELP = '/app/help',
    TOOLS = '/app/tools',
    EXPERIMENTS = '/app/experiments',
    EXPERIMENTS_NEW = '/app/experiments/new',
    EXPERIMENTS_EDIT = '/app/experiments/:id',
    COUPONS = '/app/tools/coupons',
    USAGE_RECORDER = '/app/tools/usage',
    BILLING = '/app/billing',
    INVOICES = '/app/tools/invoices',
}
